import { matchPath } from 'react-router-dom';
import { routeToGtmNameMap } from '@dtna/dvs-core-dcp-client-constants/lib/constants/routes';

const getRoutePatternFromLocation = (location: string):(string | null) => {
  let routeMatch: string | null = null;
  const keys = routeToGtmNameMap.keys();
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    const matchTest = matchPath(key, location);
    if (matchTest) {
      routeMatch = matchTest.pattern.path;
      break;
    }
  }
  return routeMatch;
};

export default getRoutePatternFromLocation;
